import React, {useRef} from 'react';
import '../css/formats.css';
import { useReactToPrint } from "react-to-print";
import { FORMAT_NUMBER, CURRENCY, SYMBOL } from '../libs/utils/Const';


export const FormatOrderSaleModal = (props) => {
    const { orderModel } = props;
    const folio = "OR"+orderModel.DocEntry;
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Pedido_'+folio,
        onafterprint: () => alert('Print Success')
    })
    
    return ( 
        
        <div>
            <div className="modal fade" id="formatOrderSaleModal" data-keyboard="true" tabIndex="-1" aria-labelledby="formatOrderSaleModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-xl" >
                    <div className="modal-content text-responsive">
                        <div className="modal-header">
                            
                        </div>
                        <div ref={componentRef} className="modal-body scrollPage" id="printOrder">
                            <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}}>
                                <div className='row'>
                                    <div className='col-7 text-right'/>
                                    <div className='col-4 text-left pld-110' style={{paddingLeft:"110px"}}>
                                        <h4><strong>Pedido</strong></h4>
                                        <span><strong>Fecha y Hora de emisión:</strong></span><br/>
                                        <span>{orderModel.DocDate+"   "+orderModel.DocTime}</span>
                                    </div>
                                    <div className='col-1 text-right text-vertical'>
                                        <span className='text-vertical pr-1 pv'style={{color:"white", background: "#ccc"}}><strong>{folio}</strong></span>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-5">
                                        <p>
                                            <strong>Cliente No</strong> CC1659 <br/>
                                            LUCERO MENDIVIL JORGE FRANCISCO<br/>
                                            <strong>RUT:</strong> LUMJ601206FB2 <br/>
                                            ENVIAR A MOLINO DE FLORES POR EL BLVD. JESUS KUMATE<br/>
                                            FTE A CONCRETERA CEMEX. No. .<br/>
                                            Col. RECIBE ARQ. JORGUE LUCERO CEL 66 71 38 75 46<br/>
                                            **PAGADA** CP..
                                        </p>
                                    </div>
                                    <div className="col-3">
                                        <p>
                                            <strong>Ejemplo SA de CV</strong><br/>
                                            RUT: 12340117NN8<br/>
                                            Calle Pazos no. 123<br/>
                                            Col. San Luis CP 84160<br/>
                                            Hermosillo, Sonora, Mexico.<br/>
                                            Tel: 662.2.15 .30.90
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Vendedor:</strong> SIN ASIGNAR <br/>
                                            <strong>Valida hasta:</strong>  <br/>
                                            <strong>Correo :</strong>  <br/>
                                            <strong>Teléfono:</strong>  <br/>
                                            <strong>Precios de contacto:</strong>
                                            
                                        </p>
                                    </div>
                                </div>
                                <div className='row mt-1' style={{paddingRight:"15px"}}>
                                    <table>
                                        <thead style={{borderTop: "solid 3px", borderBottom: "solid 3px"}}>
                                            <tr>
                                                <th className='pl-5'>Cantidad</th>
                                                <th>m2</th>
                                                <th>Descripción</th>
                                                <th>Descuento</th>
                                                <th>Precio m2</th>
                                                <th>Precio</th>
                                                <th>Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{borderBottom: "solid 3px"}}>
                                        {!!orderModel.Items &&
                                            orderModel.Items.map((item, index) => {
                                                return (
                                                    <tr>
                                                        <td className='pl-5'>{item.Quantity}</td>
                                                        <td>0</td>
                                                        <td>{item.ItemName.substring(0,25)}</td>
                                                        <td>0%</td>
                                                        <td>0</td>
                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(item.Price)}</td>
                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(item.Total)}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='row mt-5'>
                                    <div className='col-7'>
                                        <p>
                                            <h5><strong>Referencia de pago:</strong><br/></h5>
                                            HSBC 12345678865 CLABE:1234532222 1964 BANAMEX 1234567 SUC. 7003<br/>
                                            CLABE: 002760700318632698.<br/>
                                            <br/>
                                            <strong>Agradecemos sus comentarios y sugerencias en : hola@ejemplo.com.mx</strong><br/>
                                        </p>
                                    </div>
                                    <div className='col-2'></div>
                                    <div className='col-3'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Subtotal: </strong></td>
                                                    <td style={{ minWidth:"100px"}}>{CURRENCY + ' ' + FORMAT_NUMBER.new(orderModel.Subtotal)}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Descuento: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(orderModel.Discount)}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>IVA: {orderModel.TaxRate} % </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(orderModel.Taxes)}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Retención: </strong></td>
                                                    <td>fsdf</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Total: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(orderModel.Total)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <h4 className='mt-5'><strong>Gracias por su preferencia</strong></h4>
                                <div className='row mt-3' style={{background:"red", height:"10px"}}></div>
                                <br/>
                                <br/>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handlePrint}>Imprimir</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormatOrderSaleModal;